module.exports = __webpack_public_path__ + "static/piau-493988ce3d676bae5f1f33fcf53390b0.png";